import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RiLogoutCircleLine } from "react-icons/ri";
import cohortLogo from '../Assets/cohortLogo.svg';
import { PiUserCircle, PiDotsThreeCircle } from "react-icons/pi";
import '../Styles/sideBarStyle.css';
import { authContext } from '../Context/AuthContext';

export const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useContext(authContext);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#FFF', padding: '1rem', gap: '1rem' }}>
      <div className="d-flex gap-3">
        <div className='topNavbarLogo' />
        <div className="d-flex flex-column">
          <h1 className="topNavTitle">ConCrédito</h1>
          <p className="topNavSubTitle">Cohorts de Consignados</p>
        </div>
      </div>

      <div className='d-flex flex-column gap-3' style={{ width: '250px', gap: "1rem", alignItems: "flex-start", marginTop: '1rem' }}>
        <div className='w-100'>
          <div onClick={() => navigate('/dashboard')} className={location.pathname === "/dashboard" ? "sideBar-links-selected" : "sideBar-links"} >
            <PiDotsThreeCircle size={25} /> <span style={{ marginLeft: '10px' }}>Home</span>
          </div>
        </div>
        <div className='w-100'>
          <div onClick={() => navigate('/users')} className={location.pathname === "/users" ? "sideBar-links-selected" : "sideBar-links"}>
            <PiUserCircle size={25} /> <span style={{ marginLeft: '10px' }}>Usuários</span>
          </div>
        </div>
        <div className="w-100">
          <div
            onClick={() => navigate('/cohorts')}
            className={location.pathname === "/cohorts" ? "sideBar-links-selected" : "sideBar-links"}
            style={{ cursor: 'pointer' }}
          >
            <img src={cohortLogo} alt="cohort" />
            <span style={{ marginLeft: '10px' }}>Cohorts</span>
          </div>

        </div>
      </div>

      <div className='mt-5'>
        <div className="sideBar-links" onClick={() => { auth.signOut(); navigate('/') }} >
          <RiLogoutCircleLine size={25} /> <span style={{ marginLeft: '10px' }}>Sair</span>
        </div>
      </div>
    </div>
  );
};
